export const GROUP_SHOW_RESET = 'GROUP_SHOW_RESET'
export const GROUP_SHOW_SET_ERROR = 'GROUP_SHOW_SET_ERROR'
export const GROUP_SHOW_SET_RETRIEVED = 'GROUP_SHOW_SET_RETRIEVED'
export const GROUP_SHOW_TOGGLE_LOADING = 'GROUP_SHOW_TOGGLE_LOADING'
